module.exports = __webpack_public_path__ + "img/marketplace_Foodpanda.a040897d.svg";